import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CourseManagement } from './CourseManagement';
import { ContentManagement } from './ContentManagement';
import { AdminGuard } from '../guards/AdminGuard';

export const EducationManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('courses');

  return (
    <AdminGuard>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Education Management</h1>
          <p className="text-muted-foreground">
            Manage courses, modules, slides, and quiz content for the education platform.
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="courses">Course Management</TabsTrigger>
            <TabsTrigger value="content">Module Management</TabsTrigger>
          </TabsList>

          <TabsContent value="courses" className="space-y-6">
            <CourseManagement />
          </TabsContent>

          <TabsContent value="content" className="space-y-6">
            <ContentManagement />
          </TabsContent>
        </Tabs>
      </div>
    </AdminGuard>
  );
};